import type { IUiWorkCalendar } from '../provider/UiContext';

const DEFAULT_HOLIDAYS = [0, 6];

const isDateInArray = (array: Date[], value: Date) => array.some((item) => item.getTime() === value.getTime());

/** Ключ даты в `holidayNames`: `getTime()` её локальной полуночи. */
export const workCalendarDayKey = (date: Date): number =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

/** Предикат выходного дня по рабочему календарю; дата сравнивается с локальной полуночью строго по `getTime()`. */
export function createWorkCalendarHolidayPredicate({
    extraWorkingDays,
    extraHolidays,
}: Pick<IUiWorkCalendar, 'extraWorkingDays' | 'extraHolidays'>): (date: Date) => boolean {
    return (date: Date): boolean => {
        if (isDateInArray(extraWorkingDays, date)) return false;
        if (isDateInArray(extraHolidays, date)) return true;
        return DEFAULT_HOLIDAYS.includes(date.getDay());
    };
}
